import React from 'react';
import ReactDOM from 'react-dom';
import { Router, browserHistory } from 'react-router';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import Analytics from '@climatecentral/analytics';
import * as reducers from './reducers';
import { ActionTypes, SetWaterLevel, SetPlace, SetQuery, SetForecastName, SetForecastType,
         SetImpact, SetImpactGroup, SetImpactPct, SetProtection, SetComparisonType, SetStationNum } from './actions';
import { GOOGLE_ANALYTICS } from './config';
import routes from './routes';
import { locationToState } from './utils/utils';

let cssContainer = document.getElementById('css');
const appContainer = document.getElementById('app');

window.analytics = new Analytics({
  id: GOOGLE_ANALYTICS.ga4MeasurementId,
});

function enableBatching(reducer) {
  return function batchingReducer(state, action) {
    if (action.type === ActionTypes.BATCH_ACTIONS) {
      return action.actions.reduce(batchingReducer, state);
    } else {
      return reducer(state, action);
    }
  }
}

const reducer = combineReducers(Object.assign({}, reducers));
const store = createStore(enableBatching(reducer), locationToState());

browserHistory.listen(location => {
  if (location.action === "PUSH") {
    window.ga('send', 'pageview', location.pathname);
    if (location.hash !== "") {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView();
      }
    }

    if (location.pathname === "/search") {
      store.dispatch(SetQuery(location.query.q));
      return;
    }

    if (location.state) {
      store.dispatch(SetStationNum(0));
    }
  }

  if (location.action !== "POP" || !location.state || location.pathname == "/") {
    return;
  }

  var currentState = store.getState();
  var poppedState = location.state;

  if (location.pathname == "/search") {
    if (!("q" in poppedState)) {
      poppedState.q = "";
    }

    store.dispatch(SetQuery(poppedState.q));
    return;
  }

  if (poppedState.waterLevel) {
      if (poppedState.waterLevel.level !== currentState.waterLevel.level || poppedState.waterLevel.unit !== currentState.waterLevel.unit) {
          store.dispatch(SetWaterLevel({level: poppedState.waterLevel.level, unit: poppedState.waterLevel.unit}));
        }
  }

  if (poppedState.place) {
    store.dispatch(SetPlace(poppedState.place.type, poppedState.place.id));
  }

  const actions = {
    forecastName: SetForecastName,
    forecastType: SetForecastType,
    impactPct: SetImpactPct,
    impactGroup: SetImpactGroup,
    impact: SetImpact,
    protection: SetProtection,
    comparisonType: SetComparisonType,
  }

  for (let key in Object.keys(actions)) {
    if (poppedState[key] !== currentState[key]) {
      store.dispatch(actions[key](poppedState[key]));
    }
  }
});

function run() {
  ReactDOM.render(
    <Provider store={store}>
      <Router history={browserHistory}>
        {routes}
      </Router>
    </Provider>,
    appContainer
  );

  // Remove the pre-rendered CSS because it's no longer used
  // after the React app is launched
  if (cssContainer) {
    cssContainer.parentNode.removeChild(cssContainer);
    cssContainer = null;
  }
}

// Run the application when both DOM is ready
// and page content is loaded
if (window.addEventListener) {
  window.addEventListener('DOMContentLoaded', run);
} else {
  window.attachEvent('onload', run);
}
